import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'embed',
    loadChildren: () => import('@23degrees/apps/embed/embed-page.routes'),
  },
  {
    path: '',
    loadChildren: () => import('@23degrees/atlas/atlas.routing'),
  },
  {
    path: 'ssrloading',
    loadChildren: () => import('@23degrees/atlas/pages/ssrloading-page/ssrloading-page.routes'),
  },
  {
    path: '**',
    loadChildren: () => import('@23degrees/atlas/pages/not-found/not-found.routes'),
  },
];
